define(
  'widget/cookie/view/cookie',[],function () {
    return Backbone.View.extend({
      events: {
        'click .cookie-box button': 'closeBox',
        'click .cookie-corner': 'openBox'
      },

      initialize: function () {
        if (document.cookie.indexOf('nocookie=true') === -1) {
          $('.cookie-box')
            .toggleClass('hide', false)
          $('.cookie-corner')
            .toggleClass('hide', false)
        }

        // Always set cookie
        document.cookie = 'nocookie=true; expires=Thu, 27 Dec 2035 12:00:00 GMT'
      },

      closeBox: function () {
        $('.cookie-box')
          .fadeOut()
      },

      openBox: function () {
        $('.cookie-box')
          .fadeIn()
        this.trigger('boxOpened', this)
      },

      closeCorner: function () {
        $('.cookie-corner')
          .fadeOut()
      }
    })
  })
;
